// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.att-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
  margin-top: 11px;
}

.att-thumb {
  width: 74px;
  height: 74px;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  background: var(--bg);
  cursor: zoom-in;
  transition: border-color 0.2s;
}

.att-thumb:hover {
  border-color: var(--brand);
}

.att-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.att-file {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 220px;
  padding: 10px 13px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg);
  color: var(--text-soft);
  font-size: 0.84rem;
  text-decoration: none;
  transition: border-color 0.2s, color 0.2s;
}

.att-file:hover {
  border-color: var(--brand);
  color: var(--brand);
}

.att-file span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.att-lightbox {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(30, 27, 75, 0.88);
  cursor: zoom-out;
}

.att-lightbox img {
  max-width: 100%;
  max-height: 100%;
  border-radius: var(--radius);
  cursor: default;
}

.att-close {
  position: absolute;
  top: 18px;
  right: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  cursor: pointer;
}

.att-close:hover {
  background: rgba(255, 255, 255, 0.28);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/Attachments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".att-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 9px;\n  margin-top: 11px;\n}\n\n.att-thumb {\n  width: 74px;\n  height: 74px;\n  padding: 0;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  background: var(--bg);\n  cursor: zoom-in;\n  transition: border-color 0.2s;\n}\n\n.att-thumb:hover {\n  border-color: var(--brand);\n}\n\n.att-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.att-file {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 220px;\n  padding: 10px 13px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg);\n  color: var(--text-soft);\n  font-size: 0.84rem;\n  text-decoration: none;\n  transition: border-color 0.2s, color 0.2s;\n}\n\n.att-file:hover {\n  border-color: var(--brand);\n  color: var(--brand);\n}\n\n.att-file span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.att-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 4000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(30, 27, 75, 0.88);\n  cursor: zoom-out;\n}\n\n.att-lightbox img {\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: var(--radius);\n  cursor: default;\n}\n\n.att-close {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.16);\n  color: #fff;\n  cursor: pointer;\n}\n\n.att-close:hover {\n  background: rgba(255, 255, 255, 0.28);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
